import type {
  ChannelThreadId,
  SupportTicketId,
} from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { MetaCommentChatMessageBubble } from "../message-types/meta-comment-chat-message-bubble";
import { ChatThreadView } from "./chat-thread-view";

interface FacebookThreadViewProps {
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const FacebookThreadView = memo(function FacebookThreadView({
  supportTicketId,
  thread,
}: FacebookThreadViewProps) {
  return (
    <ChatThreadView
      channel={thread.channel}
      renderMessage={(msg: Message, threadId: ChannelThreadId) => (
        <MetaCommentChatMessageBubble
          channel={thread.channel}
          message={msg}
          supportTicketId={supportTicketId}
          threadId={threadId}
        />
      )}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
